import type {
    StorageItemSvgReferenceId} from "@@/shared/storage-items/storage-item-svgs/storage-item-svg-reference-id";
import {
    storageItemSvgReferenceIdFactory,
    storageItemSvgReferenceIdZodSchema,
} from "@@/shared/storage-items/storage-item-svgs/storage-item-svg-reference-id";
import type { Except } from "type-fest";
import { z } from "zod";
import type { StorageItemReference } from "../storage-item-references/storage-item-reference";
import { storageItemReferenceBaseZodObject } from "../storage-item-references/storage-item-reference-base";

const storageItemSvgReferenceZodObject =
    storageItemReferenceBaseZodObject.merge(
        z.object({
            _id: storageItemSvgReferenceIdZodSchema,
            type: z.literal("SVG"),
            blurhash: z.string().optional(),
        }),
    );
type StorageItemSvgReference = z.infer<typeof storageItemSvgReferenceZodObject>;
const storageItemSvgReferenceZodSchema: z.ZodSchema<StorageItemSvgReference> =
    storageItemSvgReferenceZodObject;

type StorageItemSvgReferenceFactoryParams = Except<
    StorageItemSvgReference,
    "_id" | "type"
> & {
    _id?: StorageItemSvgReferenceId;
};

const storageItemSvgReferenceFactory = (
    params: StorageItemSvgReferenceFactoryParams,
): StorageItemSvgReference => {
    return {
        _id: params._id ?? storageItemSvgReferenceIdFactory(),
        type: "SVG",
        ...params,
    };
};

const isStorageItemSvgReference = (
    storageItem:
        | {
              _type: StorageItemReference["_type"];
              type: StorageItemReference["type"];
          }
        | undefined,
): storageItem is StorageItemSvgReference => {
    if (typeof storageItem === "undefined") return false;
    if (storageItem._type !== "STORAGE_ITEM_REFERENCE") return false;
    return storageItem.type === "SVG";
};

export {
    isStorageItemSvgReference,
    storageItemSvgReferenceFactory,
    storageItemSvgReferenceZodObject,
    storageItemSvgReferenceZodSchema,
};
export type { StorageItemSvgReference };
